<template>
  <BaseFilters
    :bem="bemBlock"
    :disabled="loading"
    :filter-display-name="filterDisplayName"
    :options="options"
    :selected="selected"
    :show="options && options.length > 1"
    :is-select-multiple="false"
    @select="selectFilter"
  >
    <template #optionContent="slotProps">
      {{ slotProps.option.displayName }}
    </template>
  </BaseFilters>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import BaseFilters from './BaseFilters.vue';

export default {
  name: 'BaseFiltersSorting',

  components: {
    BaseFilters,
  },

  mixins: [
    bemClassesMixin,
  ],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    filterDisplayName() {
      return this.$msg('filters.sortby.text', 'filters');
    },
  },

  methods: {
    selectFilter(option) {
      this.$emit('select', option);
    },
  },
};
</script>
